module.exports = __webpack_public_path__ + "static/6-646e8cf4cbc9e072d709832dca1ee7ba.png";